<template>
  <div class="news-bar-preview"
       :style="{
          marginLeft: ($$FormData.page_edge ) * 0.5 + 'px',
          marginRight: ($$FormData.page_edge ) * 0.5 + 'px',
          marginTop: ($$FormData.page_top_edge ) * 0.5 + 'px',
          padding: ($$FormData.page_edge ) * 0.5 + 'px',
          borderRadius: ($$FormData.page_radius ) * 0.5 + 'px',
          backgroundColor: `${$$FormData.background_color}`
        }">
    <div class="left-content">
      <div class="left-icon" v-if="$$FormData.show_left_icon">
        <img :src="`${$$FormData.left_icon_bg_style}`" alt="">
      </div>
      <div class="news-content"
           :style="{
          fontSize: ($$FormData.content_font_size ) * 0.5 + 'px',
          color: $$FormData.content_color
        }">{{ $$FormData.content || default_news }}</div>
    </div>
    <div class="right-icon" v-if="$$FormData.show_right_icon">
      <img :src="`${$$FormData.right_icon_bg_style}`" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsBarPreview",
  data() {
    return {
      default_news: '请填写内容，如果过长，将会在手机上隐藏显示'
    }
  },
  computed: {
    to_link() {
      let link = 'javascript:void(0);'
      if (!this.$$FormData.to_link) return link
      return this.$$FormData.to_link.value || link
    }
  }
}
</script>

<style scoped lang="scss">
  .news-bar-preview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .left-content {
      flex: 1;
      display: flex;
      align-items: center;
      .left-icon {
        margin: 0 10px;
        width: 30px;
        height: 30px;
      }
      .news-content {
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
    }
    .left-icon, .right-icon {
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-icon {
      width: 14px;
      height: 14px;
    }
  }
</style>